import {useCallback, useEffect, useMemo, useRef, useState} from "react";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {IApplicationModalButtonRenderProps} from "../../application/components/ApplicationModalButton";
import {ApplicationModalStep} from "../../application/types/ApplicationModalStep";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import {DELAYED_CONTACT_MODAL_MS} from "../../hotline/constants/delayed_contact_modal_ms";
import {usePromotionStyle} from "../components/Promotion";
import {getPromotionListingDefaultMessage} from "../helpers/promotion_listing_config";
import {PromotionType} from "../helpers/PromotionType";
import {getAmplitudePromotionLeadFormTrackingContext} from "../tracking/get_amplitude_promotion_lead_form_event_tracking";
import {getAmplitudePromotionModalTrackingContext} from "../tracking/get_amplitude_promotion_modal_tracking_context";
import {
    trackAmplitudePromotionModalClose,
    trackAmplitudePromotionModalSelectPromotion,
    trackAmplitudePromotionModalViewPromotion
} from "../tracking/track_amplitude_promotion_modal_events";
import {IPromotionModalProps} from "../types/IPromotionModal";

export const usePromotionModal = (props: IPromotionModalProps) => {
    const {vendorId, offerId, propertyId, promotion, fallbackTitle} = props;
    const [isOpen, setIsOpen] = useState(false);
    const hasTrackedViewPromotionRef = useRef(false);

    const promotionType = useMemo(
        () => (promotion?.type !== undefined && promotion?.type !== null ? (promotion.type as PromotionType) : PromotionType.PROMOTION),
        [promotion?.type]
    );
    const promotionStyle = usePromotionStyle(promotionType);

    const promotionTrackingContext = useMemo(
        () =>
            getAmplitudePromotionModalTrackingContext({
                promotion,
                fallbackTitle,
                offerId,
                propertyId
            }),
        [fallbackTitle, offerId, promotion, propertyId]
    );

    const applicationSource = propertyId !== null ? ApplicationSource.PromotionProperty : ApplicationSource.Promotion;

    const amplitudeLeadFormTrackingContext = useMemo(
        () =>
            getAmplitudePromotionLeadFormTrackingContext({
                promotionTrackingContext,
                applicationSource,
                ctaText: InquiryButtonTypeName.ASK_FOR_PROMOTION
            }),
        [applicationSource, promotionTrackingContext]
    );

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsOpen(true);
        }, DELAYED_CONTACT_MODAL_MS);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!isOpen || hasTrackedViewPromotionRef.current) {
            return;
        }

        hasTrackedViewPromotionRef.current = true;
        trackAmplitudePromotionModalViewPromotion(promotionTrackingContext);
    }, [isOpen, promotionTrackingContext]);

    const close = useCallback(() => {
        trackAmplitudePromotionModalClose(promotionTrackingContext);

        setIsOpen(false);
    }, [promotionTrackingContext]);

    const createAskForPromotionHandler = useCallback(
        (openModal: IApplicationModalButtonRenderProps["openModal"]) => () => {
            trackAmplitudePromotionModalSelectPromotion(promotionTrackingContext);

            setIsOpen(false);
            openModal({amplitude: amplitudeLeadFormTrackingContext});
        },
        [amplitudeLeadFormTrackingContext, promotionTrackingContext]
    );

    return {
        isOpen,
        promotionType,
        promotionStyle,
        promotionTrackingContext,
        applicationSource,
        applicationModalButtonProps: {
            flowVariant: "promotion" as const,
            initialStep: ApplicationModalStep.PROMOTION_FORM,
            source: applicationSource,
            sourceSection: ApplicationSourceSection.MODAL,
            topic: fallbackTitle
                ? {
                      message: getPromotionListingDefaultMessage(promotionType, fallbackTitle)
                  }
                : undefined,
            vendorId,
            offerId,
            propertyId
        },
        close,
        createAskForPromotionHandler
    };
};
import {useCallback, useEffect, useMemo, useRef, useState} from "react";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {IApplicationModalButtonRenderProps} from "../../application/components/ApplicationModalButton";
import {ApplicationModalStep} from "../../application/types/ApplicationModalStep";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import {DELAYED_CONTACT_MODAL_MS} from "../../hotline/constants/delayed_contact_modal_ms";
import {usePromotionStyle} from "../components/Promotion";
import {getPromotionListingDefaultMessage} from "../helpers/promotion_listing_config";
import {PromotionType} from "../helpers/PromotionType";
import {getAmplitudePromotionLeadFormTrackingContext} from "../tracking/get_amplitude_promotion_lead_form_event_tracking";
import {getAmplitudePromotionModalTrackingContext} from "../tracking/get_amplitude_promotion_modal_tracking_context";
import {
    trackAmplitudePromotionModalClose,
    trackAmplitudePromotionModalSelectPromotion,
    trackAmplitudePromotionModalViewPromotion
} from "../tracking/track_amplitude_promotion_modal_events";
import {IPromotionModalProps} from "../types/IPromotionModal";

export const usePromotionModal = (props: IPromotionModalProps) => {
    const {vendorId, offerId, propertyId, promotion, fallbackTitle} = props;
    const [isOpen, setIsOpen] = useState(false);
    const hasTrackedViewPromotionRef = useRef(false);

    const promotionType = useMemo(
        () => (promotion?.type !== undefined && promotion?.type !== null ? (promotion.type as PromotionType) : PromotionType.PROMOTION),
        [promotion?.type]
    );
    const promotionStyle = usePromotionStyle(promotionType);

    const promotionTrackingContext = useMemo(
        () =>
            getAmplitudePromotionModalTrackingContext({
                promotion,
                fallbackTitle,
                offerId,
                propertyId
            }),
        [fallbackTitle, offerId, promotion, propertyId]
    );

    const applicationSource = propertyId !== null ? ApplicationSource.PromotionProperty : ApplicationSource.Promotion;

    const amplitudeLeadFormTrackingContext = useMemo(
        () =>
            getAmplitudePromotionLeadFormTrackingContext({
                promotionTrackingContext,
                applicationSource,
                ctaText: InquiryButtonTypeName.ASK_FOR_PROMOTION
            }),
        [applicationSource, promotionTrackingContext]
    );

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsOpen(true);
        }, DELAYED_CONTACT_MODAL_MS);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!isOpen || hasTrackedViewPromotionRef.current) {
            return;
        }

        hasTrackedViewPromotionRef.current = true;
        trackAmplitudePromotionModalViewPromotion(promotionTrackingContext);
    }, [isOpen, promotionTrackingContext]);

    const close = useCallback(() => {
        trackAmplitudePromotionModalClose(promotionTrackingContext);

        setIsOpen(false);
    }, [promotionTrackingContext]);

    const createAskForPromotionHandler = useCallback(
        (openModal: IApplicationModalButtonRenderProps["openModal"]) => () => {
            trackAmplitudePromotionModalSelectPromotion(promotionTrackingContext);

            setIsOpen(false);
            openModal({amplitude: amplitudeLeadFormTrackingContext});
        },
        [amplitudeLeadFormTrackingContext, promotionTrackingContext]
    );

    return {
        isOpen,
        promotionType,
        promotionStyle,
        promotionTrackingContext,
        applicationSource,
        applicationModalButtonProps: {
            flowVariant: "promotion" as const,
            initialStep: ApplicationModalStep.PROMOTION_FORM,
            source: applicationSource,
            sourceSection: ApplicationSourceSection.MODAL,
            topic: fallbackTitle
                ? {
                      message: getPromotionListingDefaultMessage(promotionType, fallbackTitle)
                  }
                : undefined,
            vendorId,
            offerId,
            propertyId
        },
        close,
        createAskForPromotionHandler
    };
};
